<script>
	import Vue from 'vue'
	import {LayoutDirs} from '../../../enum'
	import {Watcher} from '../../../model/observer/StickObserver'
	
	export default {
		name: 'stick_',
		
		props: {
			dir: {
				type: String,
				default: LayoutDirs.VERT
			},
			
			position: {
				type: String,
				default: 'top'
			},
			
			height: {
				type: [String, Number],
				default: 'auto'
			},
			
			width: {
				type: [String, Number],
				default: '100%'
			},
			
			id: {
				type: String,
				default: 'stick_inner_' + Math.random()
			}
		},
		
		inject: ['registStick', 'clearStickContainer'],
		
		render(c){
			return c(this.dir.toUpperCase() == LayoutDirs.VERT ? 'db-row' : 'db-col', {
				attrs: {
					id: this.id
				},
				
				props: {
					width: this.width,
					height: this.height
				}
			}, this.$slots.default)
		},
		
		mounted(){
			setTimeout(() => {
				const dom = document.getElementById(this.id)
				const height = dom.getClientRects()[0].height
				const watcher = new Watcher(dom, height, this.position)
				this.registStick(watcher)
			}, 600)
			
			if(!Vue.prototype.$clearStick){
				console.log('1st')
				Vue.prototype.$clearStick = () => {
					this.clearStickContainer()
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	
</style>
